export default function BrandMark({ name, className = "" }) {
  if (name === "IBM")
    return (
      <span
        className={`font-display font-extrabold text-3xl sm:text-4xl tracking-[0.06em] text-slate-100 ${className}`}
        style={{ textShadow: "0 0 28px rgba(15,98,254,0.55)" }}
        data-testid="brand-ibm"
      >
        IBM
      </span>
    );
  if (name === "KONECTSYSTEMS")
    return (
      <span className={`font-display font-bold text-xl sm:text-2xl tracking-tight text-slate-100 ${className}`} data-testid="brand-konectsystems">
        KONECT<span className="text-konect">SYSTEMS</span>
      </span>
    );
  if (name === "3EECO")
    return (
      <span className={`font-display font-bold text-2xl sm:text-3xl tracking-tight text-slate-100 ${className}`} data-testid="brand-3eeco">
        3<span className="text-eeco">eeco</span>
      </span>
    );
  return <span className={className}>{name}</span>;
}
